import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { observer, inject } from 'mobx-react'

@inject('auth') @observer
export default class AuthLogin extends Component {

  constructor(props) {
    super(props)
    this.state = {
      login: '',
      password: '',
    }
  }

  @autobind
  handleChange({ target }) {
    this.setState({ [target.name]: target.value })
  }

  @autobind
  handleLogin(e) {
    e.preventDefault()
    this.props.auth.login({ ...this.state })
  }

  render() {
    return (
      <form
        className="form container login"
        onSubmit={this.handleLogin}
      >
        <div className="box">
          <div className="image">
            <img
              role="presentation"
              src="/static/images/logo.svg"
            />
          </div>

          <div className="">
            <div className="form-group">
              <label htmlFor="username">Benutzername</label>
              <input
                data-cy="login.username"
                type="text"
                autoFocus
                name="login"
                autoComplete="musbi-login"
                className="form-control"
                id="username"
                onChange={this.handleChange}
                value={this.state.login}
              />
            </div>
            <div className="form-group">
              <label htmlFor="password">Passwort</label>
              <input
                data-cy="login.password"
                autoComplete="current-password"
                type="password"
                name="password"
                className="form-control"
                id="password"
                onChange={this.handleChange}
                value={this.state.password}
              />
            </div>
            <p className="text-danger status" />
          </div>

          <div className="buttons">

            <button
              type="submit"
              className="btn btn-primary"
              data-cy="login.submit"
            >
              Anmelden
            </button>

            <div className="sub">
              <a
                href={`${window.APP_CONFIG.API_HOST}/password/remind`}
              >
                Passwort vergessen?
              </a>
            </div>
          </div>

        </div>
      </form>
    )
  }
}

AuthLogin.wrappedComponent.propTypes = {
  auth: PropTypes.object,
}



// WEBPACK FOOTER //
// ./src/auth/components/AuthLogin.js